import React from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import './MyPlaylistButton.scss';

export const MyPlaylistButton = ({image, onClick}) => {
  return (
    <div className={`my-playlist-button`} onClick={onClick}>
      <div className='white'></div>
      <div className='gray'></div>
      <div className='purple' style={image ? {backgroundImage: `url(${image})`} : {}}></div>
    </div>
  );
};

export default MyPlaylistButton;
